import React from 'react';
import { stateDisplayMap } from '@scheduling/services';

export function ShiftTableStatus({ status }: { status: string }) {
  const statusColorMap = {
    claimed: 'grass',
    rejected: 'coral',
    cancelled: 'coral',
    worked: 'midnight-lighter',
  };

  const lowerStatus = status.toLowerCase();
  const colorKey = statusColorMap[lowerStatus as keyof typeof statusColorMap];
  const label =
    stateDisplayMap[lowerStatus as keyof typeof stateDisplayMap].label;

  return <div className={`shift-table-status color-${colorKey}`}>{label}</div>;
}
